import {ProcessPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';

// Keep in sync with backend controllers
export enum SingletonProcessTaskSchemaName {
  DISCREPANCY_TASK_SCHEMA_NAME = 'Discrepancy',
  RECIPE_STEP_TASK_SCHEMA_NAME = 'Benchling Procedure Step Task Schema',
  ASSAY_STEP_TASK_SCHEMA_NAME = 'Benchling Assay Step Task Schema',
}

export const SINGLETON_SCHEMA_FEATURE_CONFIG_OVERRIDES: Record<
  SingletonProcessTaskSchemaName,
  Map<ProcessPlatformFeatureType, boolean>
> = {
  [SingletonProcessTaskSchemaName.DISCREPANCY_TASK_SCHEMA_NAME]: new Map([
    [ProcessPlatformFeatureType.CAPILLARY_UPDATE, false],
    [ProcessPlatformFeatureType.CONFIG_MIGRATION, false],
    [ProcessPlatformFeatureType.SCHEMA_CONFIG, false],
    [ProcessPlatformFeatureType.CAN_CREATE_SCHEMAS_WITHOUT_ADMIN_PERMS, true],
  ]),
  [SingletonProcessTaskSchemaName.RECIPE_STEP_TASK_SCHEMA_NAME]: new Map(),
  [SingletonProcessTaskSchemaName.ASSAY_STEP_TASK_SCHEMA_NAME]: new Map(),
};
